import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScroll";
import { cmes, formatMoneda } from "../../util/varios";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";

function TablaUTE() {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accute = JSON.parse(localStorage.getItem("accute"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "AÑO",
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MES",
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "nrolicencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "VALOR",
      textAlign: "center",
    },
  ];

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);

  const { TblContainer, TblHead } = useTableScroll(records, headCells, {
    fn: (items) => {
      return items;
    },
  });

  const seleccionarUte = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/valorute`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);

            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarUte();
  }, []);

  return (
    <div className="card">
      <Dimmer active={activate} />

      <div className="container">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />
                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="align-baseline"
                            style={{ textAlign: "center" }}
                          >
                            {item.anio}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{ textAlign: "start" }}
                          >
                            {cmes(parseInt(item.mes))}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{ textAlign: "center" }}
                          >
                            {moment(item.fechaaplic).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{ textAlign: "end", width: "200px" }}
                          >
                            {formatMoneda(
                              item.valor.replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaUTE;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaute.js